import { Injectable } from "@angular/core";
import { Arquivo } from '@tivic-team/manager-ts/dist/grl';
import { ConcessaoArquivoController } from "app/controllers/mob/concessao-arquivo.controller";
import { DocumentoArquivoDTO } from "app/model/dtos/ptc/documento-arquivo.dto";
import { LoaderService } from 'app/services/loader.service';
import { ConcessaoArquivoDTO } from '../../model/dtos/mob/concessao-arquivo.dto';
import { ApiService } from "../api-service.interface";
import { DocumentoArquivoSearch } from "../ptc/documento-arquivo.search";

@Injectable({
    providedIn: "root",
})

export class ConcessaoArquivoService implements ApiService<ConcessaoArquivoDTO>{

    constructor(
        private _loaderService: LoaderService,
        private _concessaoArquivoController: ConcessaoArquivoController
    ) { }

    find(search?: any): Promise<ConcessaoArquivoDTO[]> {
        throw new Error('Method not implemented.');
    }
    get(id: number): Promise<ConcessaoArquivoDTO> {
        throw new Error('Method not implemented.');
    }

    getArquivosByConcessao(search?: DocumentoArquivoSearch, id?: number): Promise<DocumentoArquivoDTO[]> {
        this._loaderService.show();
        return this._concessaoArquivoController.getArquivosByConcessao(search && search.getFilters(), id).finally(() => this._loaderService.hide());
    }

    downloadArquivo(id: number): Promise<Arquivo> {
        this._loaderService.show();
        return this._concessaoArquivoController.downloadArquivo(id).finally(() => this._loaderService.hide());
    }

    create(entity: ConcessaoArquivoDTO): Promise<ConcessaoArquivoDTO> {
        this._loaderService.show();
        return this._concessaoArquivoController.create(entity).finally(() => this._loaderService.hide());
    }
    update(entity: ConcessaoArquivoDTO): Promise<ConcessaoArquivoDTO> {
        throw new Error('Method not implemented.');
    }

    delete(entity: DocumentoArquivoDTO, cdConcessao: number): Promise<DocumentoArquivoDTO> {
        this._loaderService.show();
        return this._concessaoArquivoController.delete(entity, cdConcessao).finally(() => this._loaderService.hide());
    }
}